var collapsible_list_component_default = {
  "ltr": "-UzXs",
  "rtl": "v9p8J",
  "iconContainer": "oBuTC",
  "icon": "YLRmB",
  "isExpanded": "SOJ4l",
  "listDimensions": "R91cK"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
